import { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { MdSearch } from 'react-icons/md';
import HeaderSearch from '../Header/HeaderSearch';

const SearchSpeaker = ({ router, searchUrl, modifier, closeMenu }) => {
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [currentSearchTerm, setCurrentSearchTerm] = useState('');

  const handleSearchTerm = value => {
    setCurrentSearchTerm(value);
  };

  const handleCloseSearchBar = () => {
    setCurrentSearchTerm('');
    setIsSearchBarOpen(false);
  };

  return (
    <div className={`search-speaker ${modifier}`}>
      {currentSearchTerm && <div role="button" onClick={handleCloseSearchBar} />}

      {!isSearchBarOpen && (
        <div
          role="button"
          className="search-wrapper search-wrapper--toggler"
          onClick={() => setIsSearchBarOpen(true)}>
          <div className="search-wrapper__icon">
            <i>
              <MdSearch />
            </i>
          </div>
        </div>
      )}

      {isSearchBarOpen && (
        <HeaderSearch
          handleSearchTerm={handleSearchTerm}
          setIsSearchBarOpen={setIsSearchBarOpen}
          isSearchBarOpen={isSearchBarOpen}
          currentSearchTerm={currentSearchTerm}
          closeSearchBar={handleCloseSearchBar}
          router={router}
          searchUrl={searchUrl}
          entities={['published_speaker']}
          searchFields={['PublishedSpeaker']}
          closeMenu={closeMenu}
        />
      )}
    </div>
  );
};

SearchSpeaker.propTypes = {
  router: PropTypes.object.isRequired,
  searchUrl: PropTypes.string,
  modifier: PropTypes.string,
  closeMenu: PropTypes.func
};

SearchSpeaker.defaultProps = {
  searchUrl: 'search',
  modifier: '',
  closeMenu: () => ({})
};

export default withRouter(SearchSpeaker);
